;(function () {
  angular.module('contrast.tsv').factory('tsvApiConfig', tsvApiConfigFactory)

  function tsvApiConfigFactory($http, UserService) {
    'ngInject'

    return {
      getOrganizationTsv: function () {
        return $http.get(UserService.buildAPIUrl('/tsv/organization'))
      },
      getOnboardSettings: function () {
        return $http.get(UserService.buildAPIUrl('/tsv/onboard'))
      },
      updateOnboardSettings: function () {
        return $http.put('/Contrast/api/ng/tsv/onboard')
      },
      updateOrganizationTsv: function (data) {
        return $http.put(UserService.buildAPIUrl('/tsv/organization'), data)
      },
      sendEmailToAdmins: function (data) {
        return $http.put(UserService.buildAPIUrl('/tsv/email'), data)
      },
      getUserTsv: function () {
        return $http.get(UserService.buildAPIUrl('/tsv/user'))
      },
      updateUserTsv: function (data) {
        return $http.put(UserService.buildAPIUrl('/tsv/user'), data)
      },
      updateUserTsvStatus: function (enabled) {
        return $http.put(UserService.buildAPIUrl('/tsv/user/enabled'), {
          enabled: enabled
        })
      },
      updateUserTsvType: function (type) {
        return $http.put(UserService.buildAPIUrl('/tsv/user/type'), {
          type: type
        })
      },
      updateUserTsvDevice: function (device) {
        return $http.put(UserService.buildAPIUrl('/tsv/user/device'), {
          device: device
        })
      },
      //Following methods don't need org
      resetTsvCredentials: function () {
        return $http.get('/Contrast/api/ng/tsv/reset')
      },
      getTsvGoogleCredentials: function () {
        return $http.get('/Contrast/api/ng/tsv/google/credentials')
      },
      authorizeGoogleTsvCode: function (data) {
        return $http.post('/Contrast/api/ng/tsv/google/authorize', data)
      },
      authorizeEmailTsvCode: function (data) {
        return $http.post('/Contrast/api/ng/tsv/email/authorize', data)
      },
      sendTsvEmailCredentials: function () {
        return $http.get('/Contrast/api/ng/tsv/email/send')
      },
      updateTsvType: function (data) {
        return $http.put('/Contrast/api/ng/tsv/type', data)
      },
      getTsvLoginValues: function () {
        return $http.get(UserService.buildAPIUrl('/tsv/login'))
      },
      authorizeCode: function (data) {
        return $http.post('/Contrast/api/ng/tsv/authorize', data)
      },
      initialize: function () {
        return $http.post('/Contrast/api/ng/tsv/initialize')
      },
      authorizeScratchCode: function (data) {
        return $http.post('/Contrast/api/ng/tsv/authorize/scratchcode', data)
      },
      sendTemporalCode: function (data) {
        return $http.post('/Contrast/api/ng/tsv/send', data)
      },
      getOnboardShown: function () {
        return $http.get('/Contrast/api/ng/tsv/onboard')
      }
    }
  }
})()
